<template>
  <b-modal
    id="share-number-modal"
    ref="shareNumberModal"
    modal-class="share-number-modal"
    title="Share your whatsapp number"
    hide-footer
    size="sm">
    <div
      class="share-button facebook"
      @click="shareOnSocialMedia('facebook')">
      <icon name="brands/facebook"/> Facebook
    </div>
    <div
      class="share-button twitter"
      @click="shareOnSocialMedia('twitter')">
      <icon name="brands/twitter"/> Twitter
    </div>
    <!--<div
      class="share-button messenger"
      @click="shareOnSocialMedia('messenger')">
      <icon name="brands/facebook-messenger"/> Messenger
    </div>-->
    <a
      :href="`mailto:?subject=${encodeURIComponent(message)}&body=${encodedUrl}`"
      target="_blank"
      class="share-button email">
      <icon name="envelope"/> Email
    </a>
    <div class="copy-area">
      <div
        v-clipboard="url"
        class="btn btn-main btn-round copy-button"
        @success="copyDone"
        @error="copyDone(false)">
        <span
          v-if="linkCopied"
          class="done">
          Link Copied!
        </span>
        <span
          v-else-if="linkError"
          class="error">
          Unable to copy :(
        </span>
        <span
          v-else
          class="link">
          {{ url }}
        </span>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ShareNumberModal',
  props: {
    phone: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      message: 'Contact us via WhatsApp',
      linkCopied: false,
      linkError: false,
    };
  },
  computed: {
    url() {
      return `https://wa.me/${this.phone}`;
    },
    encodedUrl() {
      return encodeURIComponent(this.url);
    },
  },
  methods: {
    shareOnSocialMedia(social) {
      const width = 575;
      const height = 400;
      const left = (window.innerWidth - width) / 2;
      const top = (window.innerHeight - height) / 2;
      const options = `status=1,rel=canonical,width=${width},height=${height},top=${top},left=${left}`;
      const title = encodeURIComponent(this.message);
      let shareUrl = '';

      switch (social) {
        case 'facebook': {
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${this.encodedUrl}&summary=${this.message}`;// &app_id=${this.$env.VUE_APP_FACEBOOK_APP_ID}`;
          break;
        }
        case 'twitter': {
          shareUrl = `https://twitter.com/share?url=${this.encodedUrl}&text=${title}`;
          break;
        }
        case 'messenger': {
          shareUrl = `https://www.facebook.com/dialog/send?link=${this.encodedUrl}&message=${this.message}&redirect_uri=${this.$env.VUE_APP_APP_URL}`;// &app_id=${this.$env.VUE_APP_FACEBOOK_APP_ID}`;
          break;
        }
        default: {
          break;
        }
      }

      window.open(shareUrl, `${social}-share`, options);
    },
    copyDone(success = true) {
      if (success) {
        this.linkCopied = true;
      } else {
        this.linkError = true;
      }
      setTimeout(() => {
        this.linkCopied = false;
        this.linkError = false;
      }, 1000);
    },
    show() {
      this.$refs.shareNumberModal.show();
      setTimeout(() => {
        // added to force a new digest cycle which updates the url and fixes the issue with copying the url link
        this.$forceUpdate();
      });
    },
    hide() {
      this.$refs.shareNumberModal.hide();
    },
  },
};
</script>
